/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { IMediaModel } from "@nf/common";
import { useTranslation } from "next-i18next";
import cx from "classnames";

import styles from "./SeasonSelect.module.scss";

interface SeasonSelectProps {
  seasons: IMediaModel[];
  selected?: string | number;
  onChange: (id: string | number) => void;
}

export const SeasonSelect = ({
  seasons,
  selected,
  onChange,
}: SeasonSelectProps) => {
  const { t } = useTranslation("translations");

  return (
    <div className={styles.seasons}>
      {seasons?.map((season, index) => {
        const isActive = season.Id === selected || (!selected && index === 0);

        return (
          <button
            key={season.Id}
            className={cx(styles.season, { [styles.active]: isActive })}
            onClick={() => onChange(season.Id)}
          >
            {t("web_series_information_season")} {season.OrderInParent}
          </button>
        );
      })}
    </div>
  );
};

export default SeasonSelect;
